import { Form, InputNumber, DatePicker, Input, Button, Row, Col, Tabs, message, Modal } from 'antd';
import { useState, useRef, useEffect, forwardRef, useImperativeHandle }  from 'react';
import CustomSelect  from './CustomSelect.jsx';
import CustomCheckbox  from './CustomCheckbox.jsx';
import axiosInstance from './axiosInstance.js';
import moment from 'moment';
import './Form.css'
import {tabitem,handleException, getval, formitems} from './Utils.jsx'
import {rightitems} from './defs.js'
const { TabPane } = Tabs;
const { TextArea } = Input;



const FormNote = forwardRef(({...props},ref)=>{
    const [form] = Form.useForm();
    const [recid, setRecid] = useState(0);
    const [loading, setLoading] = useState(true);   
    const url = '/getnote'
    const urlsave = '/savenote'
    
    useImperativeHandle(ref, () => ({
        open(id) { 
            form.resetFields();
            if(id) loadData(id); 
        }
    }))
 
    const items = [
        {name:"note",         label:"",required:false,     ctrl: (pp)=>(<TextArea rows={20}{...pp}  />)}, 
    ]
    
    function translate(r,dir){
        return r      
    }

    async function loadData(recid) { 
		setRecid(recid)
        setLoading(true);	
        try {
			let response = await axiosInstance.post(url, {recid:recid})
            var r = {note: response.data}
            r = translate(r,0)  
            form.setFieldsValue(r);        
		} catch (err) {  
            handleException(err)
		} finally {
			setLoading(false);
		}
	};

    async function saveData() {
		setLoading(true);
		try {
			const response = await axiosInstance.post(urlsave, {recid:recid, ...translate(form.getFieldsValue(),1)});
            message.success('Záznam byl úspěšně uložen');
            console.log(response)
		} catch (err) {
            handleException(err)
		} finally {
			setLoading(false);
		}
	};
  
    function handleFinish(values){
        console.log('Form Values:', values);
        saveData();
    };
    
    return (
        <div>
        <Form
            form={form}
            name={'noteForm'}
            labelCol={{ span: 0 }}
            onFinish={handleFinish}
            //onValuesChange={handleChange}
            //disabled={!writeRight}
        >           
            {formitems(items,{},{})}
             
            <Form.Item wrapperCol={{ offset: 10, span: 24 }}>
                <Button type="primary" htmlType="submit">Uložit</Button>
            </Form.Item>
        </Form>
        </div>
    )
})
export default FormNote;




